// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b825d557","453":"1294ca5f","455":"a448acd2","977":"105ac068"}[chunkId] + ".chunk.js";
};